import React from 'react';
import {useIntl} from "react-intl";
import CommonPopup from "../../../_common/components/CommonPopup";
import {ProjectName} from "../ProjectName/ProjectName";
import can from "../../../_common/components/Permissions/can";

const PopupCreateProject = () => {
  const intl = useIntl();
  const buttonOpenPopupLabel = intl.formatMessage({
      id: "projects-popup-open-button-label",
      defaultMessage: "Create project",
    });
  const header = intl.formatMessage({
      id: "projects-popup-header-create",
      defaultMessage: "Create project",
    });
  const disabledCondition = !can('full', 'projectsPage');
  const buttonOpenPopupClassName = `btn d-flex align-items-center custom-subheader-button h-20px ml-16 ${disabledCondition ? 'custom-disabled-button cursor-default' : ''}`

  return (
    <CommonPopup
      buttonOpenPopupClassName={buttonOpenPopupClassName}
      buttonOpenPopupLabel={buttonOpenPopupLabel}
      header={header}
      disabled={disabledCondition}
      content={() => {
        return (
            <div className={'mb-10 d-flex justify-content-center'}>
              <ProjectName />
            </div>
        )
      }}
      size={'lg'}
    />
  );
};

export default PopupCreateProject;